import { put, takeLatest } from "redux-saga/effects";
import {
  fetchDataRequest,
  fetchDataSuccess,
  fetchDataFailure,
  fetchFiltersSuccess,
  fetchFiltersFailure,
  fetchFiltersRequest,
  fetchPoliciesDataRequest,
  fetchPoliciesDataSuccess,
  fetchPoliciesDataFailure,
  fetchOpStrategiesDataRequest,
  fetchOpStrategiesDataSuccess,
  fetchOpStrategiesDataFailure,
  fetchLessonsLearnedDataRequest,
  fetchLessonsLearnedDataSuccess,
  fetchLessonsLearnedDataFailure,
  fetchTestDataRequest,
  fetchTestDataSuccess,
  fetchTestDataFailure,
} from "./apiSlice";
import backendURL from "utils/config";
import fastAPIBaseURL from "utils/fastapiConfig";

function* fetchDataSaga(action) {
  // Fetch data from the API based on the dataset name
  const datasetName = action.payload;
  try {
    const response = yield fetch(`${backendURL}/${datasetName}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = yield response.json();
    yield put(fetchDataSuccess({ datasetName, data }));
  } catch (error) {
    console.error("Error in fetchDataSaga:", error);
    yield put(fetchDataFailure(error.message));
  }
}
function* fetchFilters(action) {
  // Fetch filters from the API based on the dataset name
  const datasetName = action.payload;
  try {
    const response = yield fetch(`${backendURL}/${datasetName}/filters`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = yield response.json();
    yield put(fetchFiltersSuccess({ datasetName, data }));
  } catch (error) {
    console.error("Error fetching filters:", error);
    yield put(fetchFiltersFailure(error.message));
  }
}

function* fetchPoliciesDataSaga(action) {
  try {
    const lang = action.payload?.lang || "en";
    const slug = action.payload?.slug;

    let url = `${fastAPIBaseURL}/policies?lang=${lang}`;
    if (slug) {
      url += `&slug=${slug}`;
    }

    const response = yield fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = yield response.json();
    console.log("🔥 policies API response:", data);

    yield put(fetchPoliciesDataSuccess({ data }));
  } catch (error) {
    console.error("Error in fetchPoliciesDataSaga:", error);
    yield put(fetchPoliciesDataFailure(error.message));
  }
}


function* fetchOpStrategiesDataSaga(action) {
  try {
    const lang = action.payload?.lang || "en";
    const slug = action.payload?.slug;
    // Fetch from FastAPI backend instead of Node.js backend
    let url = `${fastAPIBaseURL}/op_strategies?lang=${lang}`;
     if (slug) {
      url += `&slug=${slug}`;
    }
    const response = yield fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = yield response.json();
    console.log("🔥 op_strategies API response:", data);

    yield put(fetchOpStrategiesDataSuccess({ data }));
  } catch (error) {
    console.error("Error in fetchOpStrategiesDataSaga:", error);
    yield put(fetchOpStrategiesDataFailure(error.message));
  }
}


function* fetchLessonsLearnedDataSaga(action) {
  try {
    const lang = action.payload?.lang || "en";
    const slug = action.payload?.slug;

    let url = `${fastAPIBaseURL}/past_experiences?lang=${lang}`;
    if (slug) {
      url += `&slug=${slug}`;
    }

    const response = yield fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = yield response.json();
    console.log("🔥 past_experiences API response:", data);

    yield put(fetchLessonsLearnedDataSuccess({ data }));
  } catch (error) {
    console.error("Error in fetchLessonsLearnedDataSaga:", error);
    yield put(fetchLessonsLearnedDataFailure(error.message));
  }
}


function* fetchTestDataSaga(action) {
  try {
    const response = yield fetch(`${backendURL}/test`);
    const data = yield response.json();
    yield put(fetchTestDataSuccess({ data }));
  } catch (error) {
    console.error("Error in fetchTestDataSaga:", error);
    yield put(fetchTestDataFailure(error.message));
  }
}

export function* watchDataSaga() {
  yield takeLatest(fetchDataRequest, fetchDataSaga); // Listen for fetchDataRequest actions and call fetchDataSaga
  yield takeLatest(fetchFiltersRequest, fetchFilters); // Listen for fetchFiltersRequest actions and call fetchFilters
  yield takeLatest(fetchPoliciesDataRequest, fetchPoliciesDataSaga);
  yield takeLatest(fetchOpStrategiesDataRequest, fetchOpStrategiesDataSaga);
  yield takeLatest(fetchLessonsLearnedDataRequest, fetchLessonsLearnedDataSaga);
  yield takeLatest(fetchTestDataRequest, fetchTestDataSaga)
}
